import { render, staticRenderFns } from "./AddWebPagesByHand.vue?vue&type=template&id=5b878a10&scoped=true"
import script from "./AddWebPagesByHand.vue?vue&type=script&lang=ts"
export * from "./AddWebPagesByHand.vue?vue&type=script&lang=ts"
import style0 from "./AddWebPagesByHand.vue?vue&type=style&index=0&id=5b878a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b878a10",
  null
  
)

export default component.exports